var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayerUpDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 466.8 359.1",
    style: {
      enableBackground: "new 0 0 466.8 359.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.2,238.1l24.1-18l-23.9-17.7l-34.7,25.5c-7.4,5.9-7.7,12.4-0.9,19.4c0.2,0.3,0.5,0.7,0.9,1l150.7,110.8 L461,248.3c0.4-0.3,0.7-0.7,0.8-1c6.8-7,6.6-13.5-0.8-19.4l-36.2-26.5l-24.6,17l26.4,19.7l-116.8,86.8L193.2,238.1 M59.5,214 c-0.4,0.2-0.6,0.4-0.8,0.8v98.5l-42.3-41c-6.3-1.5-10.8-0.8-13.5,2.1c-2.9,3.1-3.6,7.6-2,13.6L58.2,343c3.8,3.6,7.3,5.6,10.8,5.9 c3.4-0.3,7.1-2.3,11-5.9l57.4-55.1c1.5-6,0.9-10.5-2-13.6c-2.7-2.9-7.3-3.6-13.6-2.1l-42.2,41v-98.5c-0.2-0.3-0.4-0.6-0.5-0.8 c-3.4-3.4-6.7-5-10-4.6C65.7,209,62.6,210.6,59.5,214 M157.9,130.2c0.2,0.3,0.5,0.7,0.9,1L309.5,242L461,131.2 c0.4-0.3,0.7-0.7,0.8-1c6.8-7,6.6-13.5-0.8-19.4L309.5,0L158.8,110.8C151.4,116.7,151.1,123.2,157.9,130.2 M426.5,121 l-116.8,86.9L193.2,121l116.5-86.9L426.5,121 M80,16.3c-3.9-3.6-7.6-5.6-11-5.9c-3.4,0.3-7,2.3-10.8,5.9L0.8,71.4 c-1.5,6-0.9,10.5,2,13.6c2.7,2.9,7.2,3.6,13.5,2l42.3-41v98.5c0.2,0.3,0.4,0.6,0.8,0.8c3.1,3.4,6.2,5,9.5,4.6 c3.3,0.4,6.6-1.2,10-4.6c0.2-0.2,0.3-0.4,0.5-0.8V46l42.2,41c6.3,1.5,10.9,0.9,13.6-2c2.9-3.1,3.6-7.6,2-13.6L80,16.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayerUpDownIcon);
export default __webpack_public_path__ + "static/media/layer_up_down_icon.c2c8970f.svg";
export { ForwardRef as ReactComponent };